import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { errorCodeFromQuery, withErrorCode } from '../../api/errorCodes';

/**
 * Shows why the last sign-in failed. The backend's /auth/callback sends the
 * browser back to the login page with ?error_code=11xxx (CB25SES-1804); the
 * code picks the message and is shown with it so support can look it up.
 */
export function AuthErrorAlert({ className }: { className?: string }) {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const code = errorCodeFromQuery(searchParams.get('error_code'));
  if (!code) return null;

  const message = t(`signInError.${code}`, {
    defaultValue: t('signInError.default'),
  });
  return (
    <Alert severity="error" className={className} role="alert">
      {withErrorCode(message, code)}
    </Alert>
  );
}
